// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"c12bb059","453":"a7d99afe","712":"0dc4501b","973":"9ce1dd87"}[chunkId] + ".chunk.js";
};